import { OFFER_NOT_ACCEPTED_MARKETPLACE_ERROR_REASON } from '@/shared/errors/marketplace-api-error-message';

export const CLIENT_REVIEWS_SYNC_OFFER_NOT_ACCEPTED_SKIP_REASON = OFFER_NOT_ACCEPTED_MARKETPLACE_ERROR_REASON;
export const CLIENT_REVIEWS_SYNC_QUOTA_EXHAUSTED_SKIP_REASON = 'billing_token_quota_exhausted' as const;

export const CLIENT_REVIEWS_SYNC_SKIPPED_REASONS = [
    CLIENT_REVIEWS_SYNC_OFFER_NOT_ACCEPTED_SKIP_REASON,
    CLIENT_REVIEWS_SYNC_QUOTA_EXHAUSTED_SKIP_REASON,
] as const;

export type ClientReviewsSyncSkippedReason = (typeof CLIENT_REVIEWS_SYNC_SKIPPED_REASONS)[number];
export type ClientReviewsSyncSkippedMessageLocale = 'ru' | 'en';

const CLIENT_REVIEWS_SYNC_SKIPPED_MESSAGES: Record<
    ClientReviewsSyncSkippedMessageLocale,
    Record<ClientReviewsSyncSkippedReason, string>
> = {
    ru: {
        [CLIENT_REVIEWS_SYNC_OFFER_NOT_ACCEPTED_SKIP_REASON]: 'Импорт отзывов пропущен: сначала примите оферту.',
        [CLIENT_REVIEWS_SYNC_QUOTA_EXHAUSTED_SKIP_REASON]:
            'Импорт отзывов пропущен: закончились токены для импорта отзывов. Пополните баланс и повторите синхронизацию.',
    },
    en: {
        [CLIENT_REVIEWS_SYNC_OFFER_NOT_ACCEPTED_SKIP_REASON]: 'Review import skipped: accept the offer first.',
        [CLIENT_REVIEWS_SYNC_QUOTA_EXHAUSTED_SKIP_REASON]:
            'Review import skipped: review import tokens are exhausted. Top up the balance and retry sync.',
    },
};

export const isClientReviewsSyncSkippedReason = (reason: unknown): reason is ClientReviewsSyncSkippedReason =>
    typeof reason === 'string' &&
    CLIENT_REVIEWS_SYNC_SKIPPED_REASONS.includes(reason as ClientReviewsSyncSkippedReason);

export const isClientReviewsSyncQuotaExhaustedSkipReason = (
    reason: unknown,
): reason is typeof CLIENT_REVIEWS_SYNC_QUOTA_EXHAUSTED_SKIP_REASON =>
    reason === CLIENT_REVIEWS_SYNC_QUOTA_EXHAUSTED_SKIP_REASON;

export const resolveClientReviewsSyncSkippedMessage = ({
    reason,
    locale = 'ru',
}: {
    reason: ClientReviewsSyncSkippedReason;
    locale?: ClientReviewsSyncSkippedMessageLocale;
}): string => CLIENT_REVIEWS_SYNC_SKIPPED_MESSAGES[locale]?.[reason] ?? CLIENT_REVIEWS_SYNC_SKIPPED_MESSAGES.ru[reason];
